import { useCallback } from 'react';
import { Box, Divider } from 'bonfire-kindling';

import { useInfiniteSavedSearchProfiles } from 'helpers/opportunities';
import { useInfiniteScroll } from 'helpers/hooks';
import { Loader } from 'components';
import SavedSearchListItem from './SavedSearchListItem';

const SavedSearchList = ({ onDelete }) => {
  const { searchProfiles, isLoading, isFetchingNextPage, hasNextPage, fetchNextPage } =
    useInfiniteSavedSearchProfiles();

  const loadTriggerRef = useInfiniteScroll(
    useCallback(() => {
      fetchNextPage();
    }, [fetchNextPage]),
    { rootMargin: '100px' }
  );

  if (isLoading) {
    return <Loader variant="puff" isCentered />;
  }

  if (!searchProfiles.length) {
    return null;
  }

  return (
    <>
      <Divider />
      <Box
        component="ul"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          py: 2,
          px: 0,
          m: 0,
          maxHeight: '15rem',
          listStyleType: 'none',
          overflowY: 'auto',
        }}
      >
        {searchProfiles.map(profile => (
          <SavedSearchListItem key={profile.id} onDelete={() => onDelete(profile)} {...profile} />
        ))}
        <Box component="li">
          {hasNextPage &&
            (isFetchingNextPage ? (
              <Loader variant="puff" isCentered />
            ) : (
              <div ref={loadTriggerRef} />
            ))}
        </Box>
      </Box>
    </>
  );
};

export default SavedSearchList;
